import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseCollectionComponent } from '../base-collection.component';

@Component({
  selector: 'boi-radio-card-group',
  templateUrl: './radio-card-group.component.html',
  styleUrls: ['./radio-card-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadioCardGroupComponent,
      multi: true
    }
  ]
})
export class RadioCardGroupComponent extends BaseCollectionComponent {
  @Input() radioCardGroupLabel: string;
  @Input() radioCardGroupDescription: string;
  @Input() public isTooltipLast = true;
  @Input() public disabledOptionCodes: Array<string> = [];
}
